import { pascalCase } from "change-case";

import type { NodeRole } from "@skilitics/nautilus-core";

// User-facing labels for node roles, overriding the pascalCase of the role name.
const roleLabels: Partial<Record<NodeRole, string>> = {
  unit: "Activity",
  "unit-group": "Group",
  activity: "Content",
  interlude: "Overlay",
  composable: "Element",
  "activity-frame": "Frame",
  "interlude-content": "Overlay Content",
};

export const getNodeRoleLabel = (role: NodeRole | undefined): string | undefined => {
  if (!role) return undefined;
  return roleLabels[role] ?? pascalCase(role);
};
